import { Radio } from '@ksyos/design-system';
import { adviceGeneralPractitionerNoOsaOptions } from '@common/validation/customControls/osas/osasConsultSchemas/osasConsultReadSchema';
import {
    RadioGroupFormGroup,
    TextAreaFormGroup,
    TextInputFormGroup,
} from '@frontend/components/pages/episodeCategory/customControls/processActivityFormGroupFields';
import { TherapielandProgrammesEdit } from '@frontend/components/pages/episodeCategory/therapielandProgrammes/TherapielandProgrammesEdit';
import type { PolicyFormSectionProps } from './PolicyFormSection';

export function OsaNoPolicy(props: Readonly<PolicyFormSectionProps>) {
    const { data, onChange, errors } = props;

    return (
        <>
            <RadioGroupFormGroup
                fieldKey="adviceGeneralPractitionerNoOsa"
                isRequired={true}
                label="Advies aan huisarts"
                layout="horizontal"
                onChange={async (value) => {
                    onChange(
                        {
                            adviceGeneralPractitionerNoOsa: value,
                            remarkAdviceGeneralPractitionerNoOsa: null,
                        },
                        ['adviceGeneralPractitionerNoOsa']
                    );
                }}
                radioGroupLayout="column"
                value={data.adviceGeneralPractitionerNoOsa ?? undefined}
            >
                {adviceGeneralPractitionerNoOsaOptions.map((fieldKey) => {
                    return (
                        <Radio
                            key={fieldKey}
                            label={fieldKey}
                            value={fieldKey}
                        />
                    );
                })}
            </RadioGroupFormGroup>

            {data.adviceGeneralPractitionerNoOsa === 'Anders, namelijk...' && (
                <TextInputFormGroup
                    fieldKey="remarkAdviceGeneralPractitionerNoOsa"
                    label=""
                />
            )}

            <TextAreaFormGroup
                fieldKey="remarkNoOsa"
                label="Toelichting"
            />
            <TherapielandProgrammesEdit
                checkedTreatments={data.checkedTreatments}
                errors={errors}
                onChange={onChange}
            />
        </>
    );
}
